"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_lib_1 = require("common-lib");
exports.default = (fetchFunction) => {
    const caller = common_lib_1.defaultAPICallBase(fetchFunction);
    return { changelog: { get: caller({
                paramKeys: [],
                url: "/api/changelog",
                method: "get",
                requiresMember: "unused",
                needsToken: false
            }), add: caller({
                paramKeys: [],
                url: "/api/changelog",
                method: "post",
                requiresMember: "required",
                needsToken: true
            }) }, errors: { clientError: caller({
                paramKeys: [],
                url: "/api/errors/clienterror",
                method: "post",
                requiresMember: "optional",
                needsToken: false
            }), getErrors: caller({
                paramKeys: [],
                url: "/api/errors",
                method: "get",
                requiresMember: "required",
                needsToken: false
            }), markErrorDone: caller({
                paramKeys: [],
                url: "/api/errors",
                method: "post",
                requiresMember: "required",
                needsToken: true
            }) }, events: { account: { create: caller({
                    paramKeys: [],
                    url: "/api/events/account/",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }) }, attendance: { get: caller({
                    paramKeys: ["id"],
                    url: "/api/events/:id/attendance",
                    method: "get",
                    requiresMember: "required",
                    needsToken: false
                }), add: caller({
                    paramKeys: ["id"],
                    url: "/api/events/:id/attendance",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }), addBulk: caller({
                    paramKeys: ["id"],
                    url: "/api/events/:id/attendance/bulk",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }), delete: caller({
                    paramKeys: ["id"],
                    url: "/api/events/:id/attendance",
                    method: "delete",
                    requiresMember: "required",
                    needsToken: true
                }), modify: caller({
                    paramKeys: ["id"],
                    url: "/api/events/:id/attendance",
                    method: "put",
                    requiresMember: "required",
                    needsToken: true
                }) }, debrief: { add: caller({
                    paramKeys: ["id"],
                    url: "/api/events/:id/debrief",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }), delete: caller({
                    paramKeys: ["id", "timestamp"],
                    url: "/api/events/:id/debrief/:timestamp",
                    method: "delete",
                    requiresMember: "required",
                    needsToken: true
                }) }, events: { add: caller({
                    paramKeys: [],
                    url: "/api/events/",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }), copy: caller({
                    paramKeys: ["id"],
                    url: "/api/events/:id/copy",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }), get: caller({
                    paramKeys: ["id"],
                    url: "/api/events/:id",
                    method: "get",
                    requiresMember: "optional",
                    needsToken: false
                }), getViewerData: caller({
                    paramKeys: ["id"],
                    url: "/api/events/:id/viewer",
                    method: "get",
                    requiresMember: "optional",
                    needsToken: false
                }), getAuditData: caller({
                    paramKeys: ["id"],
                    url: "/api/events/:id/audit",
                    method: "get",
                    requiresMember: "required",
                    needsToken: false
                }), getNextRecurring: caller({
                    paramKeys: [],
                    url: "/api/events/recurring",
                    method: "get",
                    requiresMember: "unused",
                    needsToken: false
                }), getUpcoming: caller({
                    paramKeys: [],
                    url: "/api/events/upcoming",
                    method: "get",
                    requiresMember: "unused",
                    needsToken: false
                }), getList: caller({
                    paramKeys: [],
                    url: "/api/events",
                    method: "get",
                    requiresMember: "optional",
                    needsToken: false
                }), getShortList: caller({
                    paramKeys: [],
                    url: "/api/events",
                    method: "get",
                    requiresMember: "optional",
                    needsToken: false
                }), getRange: caller({
                    paramKeys: ["timestart", "timeend"],
                    url: "/api/events/:timestart/:timeend",
                    method: "get",
                    requiresMember: "optional",
                    needsToken: false
                }), link: caller({
                    paramKeys: ["eventid", "targetaccount"],
                    url: "/api/events/:eventid/link/:targetaccount",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }), set: caller({
                    paramKeys: ["id"],
                    url: "/api/events/:id",
                    method: "put",
                    requiresMember: "required",
                    needsToken: true
                }), delete: caller({
                    paramKeys: ["id"],
                    url: "/api/events/:id",
                    method: "delete",
                    requiresMember: "required",
                    needsToken: true
                }) } }, files: { files: { createFolder: caller({
                    paramKeys: ["parentid", "name"],
                    url: "/api/files/:parentid/createfolder/:name",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }), get: caller({
                    paramKeys: ["id"],
                    url: "/api/files/:id",
                    method: "get",
                    requiresMember: "optional",
                    needsToken: false
                }), getFull: caller({
                    paramKeys: ["id"],
                    url: "/api/files/:id/dirty",
                    method: "get",
                    requiresMember: "optional",
                    needsToken: false
                }), setInfo: caller({
                    paramKeys: ["fileid"],
                    url: "/api/files/:fileid",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }), delete: caller({
                    paramKeys: ["fileid"],
                    url: "/api/files/:fileid",
                    method: "delete",
                    requiresMember: "required",
                    needsToken: true
                }) }, children: { getBasic: caller({
                    paramKeys: ["parentid"],
                    url: "/api/files/:parentid/children",
                    method: "get",
                    requiresMember: "optional",
                    needsToken: false
                }), getFull: caller({
                    paramKeys: ["parentid"],
                    url: "/api/files/:parentid/children/dirty",
                    method: "get",
                    requiresMember: "optional",
                    needsToken: false
                }), add: caller({
                    paramKeys: ["parentid"],
                    url: "/api/files/:parentid/children",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }), remove: caller({
                    paramKeys: ["parentid", "childid"],
                    url: "/api/files/:parentid/children/:childid",
                    method: "delete",
                    requiresMember: "required",
                    needsToken: true
                }) } }, member: { promotionrequirements: { currentuser: caller({
                    paramKeys: [],
                    url: "/api/member/promotionrequirements/currentuser",
                    method: "get",
                    requiresMember: "required",
                    needsToken: false
                }), account: caller({
                    paramKeys: [],
                    url: "/api/member/promotionrequirements/account",
                    method: "get",
                    requiresMember: "required",
                    needsToken: false
                }) }, account: { capnhq: { usernameRequest: caller({
                        paramKeys: [],
                        url: "/api/member/account/capnhq/requestusername",
                        method: "post",
                        requiresMember: "unused",
                        needsToken: false
                    }), requestNHQAccount: caller({
                        paramKeys: [],
                        url: "/api/member/account/capnhq/requestaccount",
                        method: "post",
                        requiresMember: "unused",
                        needsToken: false
                    }) }, capprospective: { requestProspectiveAccount: caller({
                        paramKeys: [],
                        url: "/api/member/account/capprospective/requestaccount",
                        method: "post",
                        requiresMember: "required",
                        needsToken: true
                    }), deleteProspectiveAccount: caller({
                        paramKeys: ["account"],
                        url: "/api/member/account/capprospective/:account",
                        method: "delete",
                        requiresMember: "required",
                        needsToken: true
                    }), upgradeProspectiveAccount: caller({
                        paramKeys: ["account"],
                        url: "/api/member/account/capprospective/:account",
                        method: "post",
                        requiresMember: "required",
                        needsToken: true
                    }) }, registerDiscord: caller({
                    paramKeys: ["discordID"],
                    url: "/api/member/account/registerdiscord/:discordID",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }), passwordResetRequest: caller({
                    paramKeys: [],
                    url: "/api/member/account/requestpasswordreset",
                    method: "post",
                    requiresMember: "unused",
                    needsToken: false
                }), finishPasswordReset: caller({
                    paramKeys: [],
                    url: "/api/member/account/finishpasswordreset",
                    method: "post",
                    requiresMember: "unused",
                    needsToken: false
                }), finishAccountSetup: caller({
                    paramKeys: [],
                    url: "/api/member/account/finishsetup",
                    method: "post",
                    requiresMember: "unused",
                    needsToken: false
                }) }, attendance: { get: caller({
                    paramKeys: [],
                    url: "/api/member/attendance",
                    method: "get",
                    requiresMember: "required",
                    needsToken: false
                }), getForGroup: caller({
                    paramKeys: [],
                    url: "/api/member/attendance/group",
                    method: "get",
                    requiresMember: "required",
                    needsToken: false
                }), getForMember: caller({
                    paramKeys: ["reference"],
                    url: "/api/member/attendance/:reference",
                    method: "get",
                    requiresMember: "required",
                    needsToken: false
                }) }, capwatch: { requestImport: caller({
                    paramKeys: [],
                    url: "/api/member/capwatch/import",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }) }, flight: { assign: caller({
                    paramKeys: [],
                    url: "/api/member/flight",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }), assignBulk: caller({
                    paramKeys: [],
                    url: "/api/member/flight/bulk",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }), membersBasic: caller({
                    paramKeys: [],
                    url: "/api/members/flight",
                    method: "get",
                    requiresMember: "required",
                    needsToken: false
                }), membersFull: caller({
                    paramKeys: [],
                    url: "/api/members/flight/full",
                    method: "get",
                    requiresMember: "required",
                    needsToken: false
                }) }, permissions: { set: caller({
                    paramKeys: [],
                    url: "/api/member/permissions",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }), get: caller({
                    paramKeys: [],
                    url: "/api/member/permissions",
                    method: "get",
                    requiresMember: "required",
                    needsToken: false
                }) }, temporaryDutyPositions: { get: caller({
                    paramKeys: ["id"],
                    url: "/api/member/tempdutypositions/:id",
                    method: "get",
                    requiresMember: "required",
                    needsToken: false
                }), set: caller({
                    paramKeys: ["id"],
                    url: "/api/member/tempdutypositions/:id",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }) }, session: { setScanAdd: caller({
                    paramKeys: [],
                    url: "/api/member/session/scanadd",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }), clone: caller({
                    paramKeys: [],
                    url: "/api/member/session/clone",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }), startMFASetup: caller({
                    paramKeys: [],
                    url: "/api/member/session/startmfasetup",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }), finishMFASetup: caller({
                    paramKeys: [],
                    url: "/api/member/session/finishmfasetup",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }), finishMFA: caller({
                    paramKeys: [],
                    url: "/api/member/session/finishmfa",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }), su: caller({
                    paramKeys: [],
                    url: "/api/member/session/su",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }), logout: caller({
                    paramKeys: [],
                    url: "/api/member/session/logout",
                    method: "post",
                    requiresMember: "unused",
                    needsToken: false
                }) }, setAbsentee: caller({
                paramKeys: [],
                url: "/api/member/absent",
                method: "post",
                requiresMember: "required",
                needsToken: true
            }), passwordReset: caller({
                paramKeys: [],
                url: "/api/member/passwordreset",
                method: "post",
                requiresMember: "required",
                needsToken: true
            }), memberList: caller({
                paramKeys: ["type"],
                url: "/api/member/list/:type?",
                method: "get",
                requiresMember: "required",
                needsToken: false
            }), getByID: caller({
                paramKeys: ["id"],
                url: "/api/member/byid/:id",
                method: "get",
                requiresMember: "required",
                needsToken: false
            }), memberSearch: caller({
                paramKeys: ["unitName", "lastName", "firstName", "dutyName", "includeAssts"],
                url: "/api/member/search/:unitName?/:lastName?/:firstName?/:dutyName?/:includeAssts?",
                method: "get",
                requiresMember: "required",
                needsToken: false
            }) }, notifications: { global: { create: caller({
                    paramKeys: [],
                    url: "/api/notifications/global",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }), get: caller({
                    paramKeys: [],
                    url: "/api/notifications/global",
                    method: "get",
                    requiresMember: "unused",
                    needsToken: false
                }) }, get: caller({
                paramKeys: ["id"],
                url: "/api/notifications/:id",
                method: "get",
                requiresMember: "required",
                needsToken: false
            }), list: caller({
                paramKeys: [],
                url: "/api/notifications",
                method: "get",
                requiresMember: "required",
                needsToken: false
            }), toggleRead: caller({
                paramKeys: ["id"],
                url: "/api/notifications/:id",
                method: "post",
                requiresMember: "required",
                needsToken: true
            }), delete: caller({
                paramKeys: ["id"],
                url: "/api/notifications/:id",
                method: "delete",
                requiresMember: "required",
                needsToken: true
            }) }, registry: { get: caller({
                paramKeys: [],
                url: "/api/registry",
                method: "get",
                requiresMember: "unused",
                needsToken: false
            }), set: caller({
                paramKeys: [],
                url: "/api/registry",
                method: "put",
                requiresMember: "required",
                needsToken: true
            }) }, tasks: { create: caller({
                paramKeys: [],
                url: "/api/tasks",
                method: "post",
                requiresMember: "required",
                needsToken: true
            }), get: caller({
                paramKeys: ["id"],
                url: "/api/tasks/:id",
                method: "get",
                requiresMember: "required",
                needsToken: true
            }), list: caller({
                paramKeys: [],
                url: "/api/tasks",
                method: "get",
                requiresMember: "required",
                needsToken: true
            }), edit: caller({
                paramKeys: ["id"],
                url: "/api/tasks/:id",
                method: "put",
                requiresMember: "required",
                needsToken: true
            }), delete: caller({
                paramKeys: ["id"],
                url: "/api/tasks/:id",
                method: "delete",
                requiresMember: "required",
                needsToken: true
            }) }, team: { members: { list: caller({
                    paramKeys: ["id"],
                    url: "/api/team/:id/members",
                    method: "get",
                    requiresMember: "optional",
                    needsToken: false
                }), modify: caller({
                    paramKeys: ["id"],
                    url: "/api/teams/:id/members",
                    method: "put",
                    requiresMember: "required",
                    needsToken: true
                }), add: caller({
                    paramKeys: ["id"],
                    url: "/api/teams/:id/members",
                    method: "post",
                    requiresMember: "required",
                    needsToken: true
                }), delete: caller({
                    paramKeys: ["id", "memberid"],
                    url: "/api/teams/:id/members/:memberid",
                    method: "delete",
                    requiresMember: "required",
                    needsToken: true
                }) }, create: caller({
                paramKeys: [],
                url: "/api/team",
                method: "post",
                requiresMember: "required",
                needsToken: true
            }), get: caller({
                paramKeys: ["id"],
                url: "/api/team/:id",
                method: "get",
                requiresMember: "optional",
                needsToken: false
            }), list: caller({
                paramKeys: [],
                url: "/api/team",
                method: "get",
                requiresMember: "optional",
                needsToken: false
            }), delete: caller({
                paramKeys: ["id"],
                url: "/api/team/:id",
                method: "delete",
                requiresMember: "required",
                needsToken: true
            }), set: caller({
                paramKeys: ["id"],
                url: "/api/team/:id",
                method: "put",
                requiresMember: "required",
                needsToken: true
            }) }, accountCheck: caller({
            paramKeys: [],
            url: "/api/accountcheck",
            method: "get",
            requiresMember: "unused",
            needsToken: false
        }), check: caller({
            paramKeys: [],
            url: "/api/check",
            method: "get",
            requiresMember: "optional",
            needsToken: false
        }), signin: caller({
            paramKeys: [],
            url: "/api/signin",
            method: "post",
            requiresMember: "unused",
            needsToken: false
        }), echo: caller({
            paramKeys: [],
            url: "/api/echo",
            method: "post",
            requiresMember: "unused",
            needsToken: false
        }), slideshowImageIDs: caller({
            paramKeys: [],
            url: "/api/banner",
            method: "get",
            requiresMember: "unused",
            needsToken: false
        }), token: caller({
            paramKeys: [],
            url: "/api/token",
            method: "get",
            requiresMember: "required",
            needsToken: false
        }) };
};
//# sourceMappingURL=index.js.map